import React from 'react';

export default function RulesModal({ open, onClose, game }) {
  if (!open) return null;
  const rules = Array.isArray(game?.rules) ? game.rules : [];
  return (
    <div role="dialog" aria-modal="true" className="rules-modal-backdrop" onClick={onClose}>
      <div className="rules-modal" onClick={(e) => e.stopPropagation()}>
        <div className="rules-modal-header">
          <h3 className="rules-modal-title">{game?.name ?? 'Game Rules'}</h3>
          <button type="button" className="rules-modal-close" onClick={onClose} aria-label="Close">✕</button>
        </div>
        {rules.length > 0 ? (
          <ol className="rules-list">
            {rules.map((r, i) => (
              <li key={i}>{r}</li>
            ))}
          </ol>
        ) : (
          <p>No rules available.</p>
        )}
      </div>
    </div>
  );
}
